import React, { useState, useEffect } from 'react';
import { Input, Button, message } from 'antd';

import IconFont from '@/components/IconFont';
import { renderIntlLabel } from '@/utils';

import { BarcodeProps } from './interface';
import styles from './payModal.module.scss';

const Barcode: React.FC<BarcodeProps> = (props) => {
  const { payModalVisible, barcodeLoading } = props;

  const [inputBarcode, setInputBarCode] = useState('');
  const [showBarCodeInput, setShowBarCodeInput] = useState(false); // 手动输入

  let code = '';
  let lastTime = 0;

  const barcodePay = (barcode) => {
    // check barcode
    if (barcode === '' || (barcode.length !== 18 && barcode.length !== 19)) {
      code = '';
      lastTime = 0;
      return;
    }
    props.submitBarcodePay(barcode);
  };

  // 扫码枪事件监听器
  function scannerCallback(event) {
    const nextTime = Date.now();
    const keycode = event.keyCode || event.which || event.charCode;

    if (keycode === 13) {
      if (lastTime && nextTime - lastTime < 30) {
        barcodePay(code);
      }

      code = '';
      lastTime = 0;
      event.preventDefault();
    } else {
      if (!lastTime) {
        code = String.fromCharCode(keycode);
      } else {
        if (nextTime - lastTime < 30) {
          code += String.fromCharCode(keycode);
        } else {
          code = '';
        }
      }
      lastTime = nextTime;
    }
  }

  // 初始化
  useEffect(() => {
    if (payModalVisible) {
      document.addEventListener('keydown', scannerCallback);
    }
  }, [payModalVisible]);

  // reset states when unmounted
  useEffect(() => {
    return () => {
      code = '';
      lastTime = 0;
      setInputBarCode('');
      setShowBarCodeInput(false);

      // remove scanner listener
      document.removeEventListener('keydown', scannerCallback);
    };
  }, []);

  const renderContent = () => {
    if (showBarCodeInput) {
      return (
        <div className={styles['pay-barcode']}>
          <Input.Search
            allowClear
            placeholder={renderIntlLabel('bill_placeholder_pay_code')}
            value={inputBarcode}
            onChange={(e) => setInputBarCode(e.target.value)}
            loading={barcodeLoading}
            enterButton={renderIntlLabel('order_action_confirm')}
            onSearch={() => {
              if (inputBarcode === '') {
                message.warning(renderIntlLabel('bill_msg_please_input_pay_code'));
                return;
              }
              if (inputBarcode.length !== 18 && inputBarcode.length !== 19) {
                message.warning(renderIntlLabel('bill_msg_please_input_18or19_pay_code'));
                return;
              }
              props.submitBarcodePay(inputBarcode);
            }}
          />
        </div>
      );
    }

    return (
      <Button style={{ marginTop: 16 }} onClick={() => setShowBarCodeInput(true)} type="link">
        手动输入
      </Button>
    );
  };

  return (
    <div className={styles['pay-content']}>
      <div className={styles['pay-animation']}>
        <span />
        <span />
        <span />
        <span />
        <i>
          <IconFont type="icon-saomadenglu" />
        </i>
        <div className={styles['pay-animation-el']} />
      </div>
      <p className={styles['pay-hint']}>请扫描顾客的支付宝/微信付款码</p>
      {renderContent()}
    </div>
  );
};

export default Barcode;
